import { Component } from '@angular/core';
import { ControlContainer, FormGroupDirective, ReactiveFormsModule } from '@angular/forms';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { BACKGROUND_CUSTOMIZATION_DESCRIPTIONS } from '../../utils/constants';
import { ColorPickerComponent } from '../color-picker/color-picker.component';
import { SectionHeaderComponent } from '../section-header/section-header.component';

@Component({
    selector: 'app-input-customization',
    imports: [ReactiveFormsModule, ColorPickerComponent, MatSlideToggleModule, SectionHeaderComponent],
    templateUrl: './input-customization.component.html',
    styleUrl: './input-customization.component.scss',
    viewProviders: [{ provide: ControlContainer, useExisting: FormGroupDirective }],
})
export class InputCustomizationComponent {
    public readonly sectionDescription = BACKGROUND_CUSTOMIZATION_DESCRIPTIONS;
}
